import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Company } from "@/features/modules/company/objects/Company";
import { companyModel } from "@/features/modules/company/models/CompanyModel";
import { DocExpiration } from "@/features/modules/doc/objects/DocExpiration";
import { DocTypeSource } from "@/features/modules/docType/objects/DocTypeSource";
import { Widget } from "@/core/modules/widget/objects/Widget";
import { widgetModel } from "@/core/modules/widget/models/WidgetModel";

export const getMissingCompanyDocs = async (): Promise<DocExpiration[]> => {
  try {
    const docExpirations: DocExpiration[] = [];

    const companies: Company[] = await companyModel.getCompaniesWithTrackExpirations();
    const widgets: Widget[] = await widgetModel.getWidgetsByTypeAndSource("missingDocs", DocTypeSource.Company);

    for (const company of companies) {
      if (company.trackExpirations === false) continue;

      const companyWidget: Widget | undefined = widgets.find((widget) => widget.source === DocTypeSource.Company && widget.sourceId === company.id);
      if (companyWidget === undefined) continue;
      if (companyWidget.values.count === 0) continue;
      if (companyWidget.values.missings == undefined) continue;

      const missings: string[] = companyWidget.values.missings as string[];
      for (const docTypeId of missings) {
        docExpirations.push(new DocExpiration(company.id, company.name ?? "-", new Date("2000-01-01"), docTypeId));
      }
    }

    return docExpirations;
  } catch (error: unknown) {
    appFaultModel.catchAppError("CompanyDocModel.getMissingCompanyDocs", {}, error);
    return [];
  }
};
